import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SchemaOrg from "@/components/feature/SchemaOrg";
import HeroSection from "./components/HeroSection";
import HotTopicsTicker from "./components/HotTopicsTicker";
import LatestArticlesGrid from "./components/LatestArticlesGrid";
import SubscribeCTA from "./components/SubscribeCTA";

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" />
      <Navbar />
      <main>
        <HeroSection />
        <HotTopicsTicker />
        <LatestArticlesGrid />
        <SubscribeCTA />
      </main>
      <Footer />
    </>
  );
}